import { Flex, Heading } from "@chakra-ui/react"
import React from "react"
import { useTranslation } from "react-i18next"

interface Props {}

const ProductFeedNotFound: React.FC<Props> = () => {
  const { t } = useTranslation()

  return (
    <Flex height="636px" alignItems="center" justifyContent="center">
      <Heading as="h1">
        {t("components.blocks.product-feed.ProductFeedNotFound.NoProductFound")}
      </Heading>
    </Flex>
  )
}

export default ProductFeedNotFound
